import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeGroupIndex: -1,
    audioUrl: '',
    siteId: '',
    album: {},
    guideArray: [],
    safari: false,
    direct: false,
    webWidth: 375,
	isSentaosaWeb: false
  },
  mutations: {
    SET_ACTIVE_GROUP_INDEX (state, value) {
      state.activeGroupIndex = value
    },
    SET_AUDIO_URL (state, url) {
      state.audioUrl = url
    },
    SET_SITEID (state, value) {
      state.siteId = value
    },
    SET_ALNUM (state, value) {
      state.album = value
    },
    SET_GUIDE_ARRAY (state, value) {
      state.guideArray = value
    },
    SET_SAFARI (state, value) {
      state.safari = value
    },
    SET_DIRECT (state, value) {
      state.direct = value
    },
    SET_WEBWIDTH (state, value) {
      state.webWidth = value
    },
	SET_IS_SENTAOSA_WEB (state, value) {
		state.isSentaosaWeb = value
	}
  },
  actions: {

  }
})
